import { useCallback, useRef } from 'react'
import { BlockerFunction, useBlocker } from 'react-router-dom'

export const useBlockerProvider = () => {
  const blockersRef = useRef<Set<BlockerFunction>>(new Set())

  const register = useCallback(
    (blockersConditionFunction: BlockerFunction) => {
      blockersRef.current.add(blockersConditionFunction)

      return () => blockersRef.current.delete(blockersConditionFunction)
    },
    [blockersRef]
  )

  const shouldBlock = useCallback(
    (params: Parameters<BlockerFunction>[0]) => {
      const isGoingToSelectAndLink =
        params.nextLocation.pathname ===
        `/${globalThis.selectAndLinkFilterSitemodel}`

      return (
        !isGoingToSelectAndLink &&
        Array.from(blockersRef.current.values()).some(
          (blockersConditionFunction) => {
            return !!blockersConditionFunction(params)
          }
        )
      )
    },
    [blockersRef]
  )

  const blocker = useBlocker(shouldBlock)

  return { blocker, register }
}
